import { AppEventEmitter, EVENT } from '@ad-lucy/utils';
import { useEffect } from 'react';
import { getDoohPreloadTime } from './getPreloadTime';

export function DoohPreloadPause() {
  useEffect(() => {
    const preloadPauseTime = getDoohPreloadTime();

    if (preloadPauseTime !== -1) {
      AppEventEmitter.Instance.lockEvent(EVENT.PLAY, DoohPreloadPause.name);
      AppEventEmitter.Instance.emit(EVENT.PAUSE);
      AppEventEmitter.Instance.emit(EVENT.RESET);

      const id = setTimeout(() => {
        AppEventEmitter.Instance.unlockEvent(EVENT.PLAY, DoohPreloadPause.name);
        AppEventEmitter.Instance.emit(EVENT.PLAY);
      }, preloadPauseTime);
      return () => clearTimeout(id);
    }

    return () => {};
  }, []);

  return null;
}
